import type { IComponentController } from "angular";
import "angular-translate";

import type { IResponseWithLoading, ITeamMember } from "App/Modules/Models";
import type { ISitesRepository } from "App/Modules/Repositories";
import { extendWithLoadingAndFail } from "App/Modules/Services";

export default class PersonsComponentController implements IComponentController {
    public static $inject: string[] = ["$translate", "mmSitesRepository"];

    public caption: string;

    public response: IResponseWithLoading<ITeamMember[]>;

    public siteId: string;

    public subCaption: string;

    constructor(
        private readonly $translate: angular.translate.ITranslateService,
        private readonly sitesRepository: ISitesRepository,
    ) {}

    public $onInit() {
        this.caption = "Entities.Site.Persons";
        this.subCaption = null;

        extendWithLoadingAndFail(this.sitesRepository.getUsersForSite(this.siteId)).subscribe((response) => {
            this.response = response;
            const teamMembers = response.data;
            if (!teamMembers) {
                return;
            }
            const loginCount = teamMembers.filter((teamMember) => teamMember.partnerUser.hasLogin).length;
            const numPersons = teamMembers.length;
            this.$translate(
                ["Entities.Site.NumPersonsFormat", "Entities.Site.PersonsWithLoginCount"],
                { numPersons, loginCount },
                "messageformat",
            ).then((translations) => {
                this.caption = translations["Entities.Site.NumPersonsFormat"];
                this.subCaption = translations["Entities.Site.PersonsWithLoginCount"];
            });
        });
    }
}
